<div class="modal-body overflow-hidden">
  <img src="{{ media.url }}" alt="..." class="img-full">
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">關閉</button>
  <button type="button" class="btn btn-danger" (click)="delete()" *ngIf="showRemove">刪除照片</button>
  <button type="button" class="btn btn-primary" (click)="pick()" *ngIf="showPick">直接使用照片</button>
</div>
